(ns pfo.form (:require
              [clojure.set]
              [cljs-time.core :as time]
              [pfo.time :refer [now]]
              [pfo.util :as util]))

(defn year-choices []
  (let [today (now)
        month (time/month today)
        year (time/year today)]
    (reverse (range (- year 100) (+ year (if (= month 12) 3 2))))))

(def month-choices
  (map-indexed (fn [index month] [(+ index 1) month])
               ["January" "February" "March" "April" "May" "June"
                "July" "August" "September" "October" "November" "December"]))

(def quarter-choices [[1 "Q1"] [2 "Q2"] [3 "Q3"] [4 "Q4"]])

(defn day-choices [year month]
  (range 1 (+ 1 (time/number-of-days-in-the-month (time/date-time year month)))))

(defn applies-to-date-parts
  "Gate the selected date parts by the active period (:month or :quarter),
   encoding iPaladin's shared 'applies to' precedence used by the document form
   and staged-document filing: quarter only in :quarter, month only in :month,
   day only alongside a month. Part values pass through untouched — callers may
   pass nil or \"0\" for unset parts; normalizing those is the caller's/backend's
   job. Year always passes through (required upstream).
   Returns {:year :quarter :month :day}."
  [period {:keys [year quarter month day]}]
  (let [quarter (when (= period :quarter) quarter)
        month   (when (= period :month) month)
        day     (when month day)]
    {:year year :quarter quarter :month month :day day}))

(defn set-selected
  "Set selected attribute depending on whether string conversion of passed values are equal"
  ([value1 value2 attrs]
   (if (= (str value1) (str value2)) (merge {:selected "selected"} attrs) attrs))
  ([value1 value2] (set-selected value1 value2 {})))

(defn option-value
  "Same as set-selected but inserts :value attribute based on value2"
  ([value1 value2 attrs]
   (let [attrs (merge attrs {:value value2 :key value2})]
     (if (= (str value1) (str value2)) (merge {:selected "selected"} attrs) attrs)))
  ([value1 value2] (option-value value1 value2 {})))

(defn unselect-if-no-value
  ([value index]
  (fn [el] (when (and el (not value)) (aset el "selectedIndex" index))))
  ([value] (unselect-if-no-value value -1)))

(defn set-checked
  "Set checked attribute depending on whether value is true"
  ([value attrs]
   (if value
     (merge {:on-change (util/handler (fn []))} attrs {:checked true :type "checkbox"})
     (merge {:on-change (util/handler (fn []))} attrs {:checked false :type "checkbox"})))
  ([value] (set-checked value {:type "checkbox"})))

(defn checked?
  "Returns true if the event comes from a checkbox that is checked"
  [event] (-> event .-target .-checked))

(defn checkbox
  ([value-atom attrs]
   [:input
    (merge {:type :checkbox
            :checked @value-atom
            :on-change #(reset! value-atom (checked? %))} attrs)])
  ([value-atom] (checkbox value-atom nil)))

(defn input-text
  ([value-atom attrs]
   [:input
    (merge {:type :text
            :value @value-atom
            :on-change #(reset! value-atom (-> % .-target .-value))} attrs)])
  ([value-atom] (input-text value-atom nil)))

(defn textarea
  ([value-atom attrs]
   [:textarea
    (merge {:type :text
            :value @value-atom
            :on-change #(reset! value-atom (-> % .-target .-value))} attrs)])
  ([value-atom] (textarea value-atom nil)))


(defn set-value
  "Set value attribute based on atom and attach basic on-change handler"
  ([value-atom attrs]
   (merge {:type "text"
           :value @value-atom
           :on-change (util/reset-from-event value-atom)}
          attrs))
  ([value-atom] (set-value value-atom {})))

(defn reset-set-choices [value-atom choices]
  (swap! value-atom
         (fn [org-ids]
           (cond
             (number? (first org-ids)) (clojure.set/intersection org-ids (set (map :id choices)))
             (vector? (first org-ids)) (into #{}
                                              (filter (fn [ids]
                                                        (every? (fn [id]
                                                                  (some (fn [choice]
                                                                          (= id (:id choice)))
                                                                        choices))
                                                                ids))
                                                      org-ids))

             :else
             org-ids))))

(defn reset-choice [value-atom choices process-item nil-value]
  (if (set? @value-atom)
    (reset-set-choices value-atom choices)
    (when (zero? (count (filterv #(= (str @value-atom) (str (process-item %))) choices)))
      (reset! value-atom nil-value))))

(defn with-disabled [disabled opts]
  (if disabled (assoc opts :disabled :disabled) opts))
